import { useRef, useState } from "react";
import "./VisualizerDataView.css";
import Header from "../../components/Header/Header";

//FontAwesome
import { faArrowLeft, faCubes, faBorderAll, faVectorSquare, faDoorClosed } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tabs from "../../shared/components/tabs/Tabs";
import DataView from '../../components/DataView/DataView';

const VisualizerDataView = () => {
  const [currentTab, setCurrentTab] = useState("1");
  const tabConfigInfo = [{id:1,name:'Racks',elementType:"rack",icon:faCubes}, {id:2,name:"Walls",elementType:"wall",icon:faBorderAll}, {id:3,name:"Areas",elementType:"area",icon:faVectorSquare}, {id:4,name:"Docks",elementType:"dock",icon:faDoorClosed}];
  const [layoutName, setlayoutName] = useState(() => localStorage.getItem("layoutName") || "");
  const tabConfig = tabConfigInfo?.map((tab, index) => {
    return {
      key: tab?.id.toString(),
      label: (
        <span className="tab-wrapper">
          <FontAwesomeIcon className="tab-icon" icon={tab?.icon} />
          {tab?.name}
        </span>
      ),
      children: currentTab === tab?.id.toString() && <DataView elementType={tab?.elementType} activeTab={currentTab} />,
    };
  });


  const onTabChange = (selectedTab) => {
    setCurrentTab(selectedTab);
  };

  return (
    <div className="data-view-container">
      <Header backHandler={<FontAwesomeIcon icon={faArrowLeft} className="back-arrow" />} title={layoutName + " Data View"} />
      <div className="tabs-container">
        <Tabs defaultActiveKey="1" config={tabConfig} onTabChange={(clickedTab) => onTabChange(clickedTab)} />
      </div>
    </div>
  );
};

export default VisualizerDataView;
